const apiConstents = {
    
    partnerCropConects:'populate=crop_connects,tenePartnerUsers,tenePartnerUsers.tene_partner_user_info,tenePartnerUsers.tene_partner_user_info.crop_edit_rights,tenePartnerUsers.tene_partner_user_info.tene_partner_roles',
    dateTimeFormat:'DD/MM/YYYY HH:mm:ss',
    dateTimeFormat1:'DD/MM/YYYY',
    dateTimeFormat2:"MMMM, DD",
    dateTimeFormat3:'DD MM YYYY',
    editRoleManager:'Content_Manager',
    editRoleExpert : 'Content_Expert',
    allDataLimit: 'pagination[limit]=-1',
    problemPopulate:'populate=partner_pg_timelines',
    problemListSort : '&sort=value',
    timelineSort : '?sort=createdAt:desc',
    timelineFilter : '&populate=partnerId,chp_problem_group,chp_problem_group.problem_group,chp_problem_group.publishedItemId,part_pg_tl_pracs&filters[chp_problem_group][id][$eq]=',
    timelinePartnerFilter:'filters[partnerId][id][$eq]=',
    
    checkProblemFilter:'&filters[$and][0][problem_group][id][$eq]=',
    checkProblemFilter2:'&filters[$and][1][partner][id][$eq]=',
    checkProblemPopulatePartner:'?populate=partner',
    checkProblemPopulate:'&populate=chp_problem_group,part_pg_tl,part_pg_tl.part_pg_tl_pracs', //!
    populateProblemGroup : '?populate=problem_group,part_pg_tls,publishedItemId,part_pg_tls.part_pg_tl_pracs',
    populateChpProblemGroup:'?populate=chp_problem_group,chp_problem_group.problem_group',
    problemSort:'&sort=problem_group.value',

    specificCropFilter : '?filters[crop_connect][id][$eq]=',
    specificPopulate:'?populate=specific_problem.problem_group,crop_connect,publishedItemId',
    partnerFilter:'&filters[partner][id][$eq]=',
    specificTimelineFilter:'?filters[partner_spg][id][$eq]=',
    specificTimelinePopulate:'&populate=partner_spg.crop_connect,partner_spg.specific_problem.problem_group,part_spg_tl_pracs,partner_spg.publishedItemId',
    specificSort:'&sort=createdAt:desc',
    filetrTimelineName:'?filters[$and][0][name][$eq]=',
    filetrTimelineName2:'&filters[$and][1][partner_spg][id][$eq]=',
    filetrProblemTimelinePartner:'&filters[$and][1][chp_problem_group][id][$eq]=',
    populateSpecificProblem:'?populate=partner_spg.specific_problem'

}
export default apiConstents;